import request from '@/utils/request';
export function auditList(data) {
  return request.post('admin/audit/list', data);
}
export function addAudit(data) {
  return request.post('admin/audit/store', data);
}
export function editAudit(data) {
  return request.post('admin/audit/edit', data);
}
export function auditDetail(data) {
  return request.post('admin/audit/detail', data);
}
export function delAudit(data) {
  return request.post('admin/audit/delete', data);
}
export function auditStatus(data) {
  return request.post('admin/audit/status', data);
}
export const markList = [{
  name: '产品上线',
  value: 'product_launch'
}, {
  name: '产品修改',
  value: 'product_change'
}, {
  name: '版本上线',
  value: 'version_online'
}, {
  name: '申请理赔',
  value: 'claims'
}];
export const typeList = [{
  name: '内容审核',
  value: 1
}, {
  name: '产品相关审核',
  value: 2
}, {
  name: '应用上线审核',
  value: 3
}, {
  name: '财务审核',
  value: 4
}, {
  name: '理赔审核',
  value: 5
}];
export function flowNodeList(data) {
  return request.post('admin/flow-node/list', data);
}
export function addFlowNode(data) {
  return request.post('admin/flow-node/store', data);
}
export function editFlowNode(data) {
  return request.post('admin/flow-node/edit', data);
}
export function flowNodeDetail(data) {
  return request.post('admin/flow-node/detail', data);
}
export function delFlowNode(data) {
  return request.post('admin/flow-node/delete', data);
}
export function flowNodeMove(data) {
  return request.post('admin/flow-node/move', data);
}